import React from 'react';
import { FloridaRequirements } from '../components/florida/FloridaRequirements';
import { FLORIDA, NORTH_CAROLINA } from '../constants';
import { GenericChoice, Qualification } from '../types';
import { NorthCarolinaRequirements } from '../components/northcarolina/NorthCarolinaRequirements';

const stateSpecificRequirements = {
    [FLORIDA]: FloridaRequirements,
    [NORTH_CAROLINA]: NorthCarolinaRequirements,
};

export function StateSpecificRequirements({
    state,
    update,
}: {
    state: string;
    update: (
        value: number | number[],
        choices: GenericChoice[],
        qualification: Qualification | null,
        category: 'education' | 'experience' | 'multiple' | 'single' | 'boolean',
    ) => void;
}) {
    const StateSpecificRequirement =
        state in stateSpecificRequirements
            ? stateSpecificRequirements[state as keyof typeof stateSpecificRequirements]
            : null;

    return StateSpecificRequirement ? <StateSpecificRequirement update={update} /> : null;
}
